import React, { useEffect, useState } from "react";
import { getselectedIds, MakeAxiosRequest } from "../../../utils/handler";
import { ModalHeader } from "../DetailsModal";
import { FormProvider, useForm } from "react-hook-form";
import { SwalError, SwalSuccess } from "../../../Components/SwalFns";
import FormFields from "../../../Components/inputs/FormFields";
import Loader from "../../../Components/loader/Loader";

function AddPermission({ proxyKey, handleBack, isLoading, setIsLoading }) {

  const methods = useForm();
  const { handleSubmit, reset, setValue, watch, trigger, getValues } = methods;

  const [response, setResponse] = useState({});
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);

  const fetchData = async (selectedKey='') => {
    setSubmitDisabled(true);
    try {
      selectedKey ? setIsLoading({ modal: false, content: true }) : setIsLoading({ modal: true, content: true });
      const res = await MakeAxiosRequest(
        "post",
        "addrelationaccountpermission",
        {
          user_proxy_key: proxyKey,
          selected_proxy_key: selectedKey,
        }
      );
      if (res.name !== "CanceledError" && res.status == 1) {
        res.data.paymentSelectionOptions = res.data.paymentSelection?.map((item) => ({
          id: item.value,
          text: item.text,
          is_selected: item.is_selected,
        }));
        res.data.searchList = res.data.proxydata?.map((item) => ({
          id: item.user_proxy_key,
          name: item.name,
          subtext: item.proxy_relation,
          img: item.image_path,
          is_selected: item.is_selected,
        }));
        // setValue("wallet_access",getselectedIds(res.data.paymentSelection,'is_selected',1))
        setResponse(res.data);
        // console.log(res.data);
        setIsLoading({ modal: false, content: false });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading({ modal: false, content: false });
    }
    setSubmitDisabled(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "selected_proxy_key") {
        fetchData(value.selected_proxy_key);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const createUser = async (data) => {
    setSubmitDisabled(true);
    try {
      const response = await MakeAxiosRequest("post", 'saveaccountpermission', { ...data, user_proxy_key: proxyKey });
      if (response.status == 1) {
        reset();
        handleBack();
        SwalSuccess({ msg: response.message});  
      } else if (response.status == 0) {
        SwalError({ msg: response.message });
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
    setSubmitDisabled(false);
  };
  
  const fields = [
    {
      name: "selected_proxy_key",
      label: "Select user",
      className: "col-12 mb-3",
      rules: { required: "Please select user" },
      type: "popupselect",
      showImage: true,
      showSearch: true,
      options: response.searchList,
      isShow: true,
    },
    {
      name: "wallet_access",
      className: "col-12 mb-3",
      rules: { required: "Please select" },
      type: "radio",
      options: response.paymentSelectionOptions,
      optionsClassName: "col-12",
      isLoading: isLoading.content,
      isShow: response.paymentSelectionOptions?.length>0,
      isShow: getValues("selected_proxy_key") ? true : false,
    },
  ];

  if(isLoading.modal) return <Loader />;
  return (
    <>
      <ModalHeader title="Add Permissions" handleBack={handleBack} />
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(createUser)}>
          <div className="form-group mt-4 view-rltionshp">
            <div className="row align-items-center">
              <div>
                <FormFields fields={fields} />
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-5 col-12">
              <button
                type="submit"
                className="btn btn-primary rounded-pill w-100 my-2 p-2"
                disabled={isSubmitDisabled}
              >
                Give Permission
              </button>
            </div>
          </div>
        </form>
      </FormProvider>
    </>
  );
}

export default AddPermission;
